import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getRouteSeoDefaults, isPrivateAppRoute } from '../../config/seo';
import { applyPageSeo } from './applyPageSeo';

/**
 * Updates title, description, canonical, Open Graph, Twitter, robots, and optional JSON-LD per route.
 */
export default function PageMeta({
  title,
  description,
  keywords,
  canonicalPath,
  ogImage,
  ogType,
  noindex,
  nofollow,
  jsonLd,
}) {
  const { pathname } = useLocation();

  useEffect(() => {
    const defaults = getRouteSeoDefaults(pathname);
    const privateRoute = isPrivateAppRoute(pathname);
    applyPageSeo({
      pathname,
      title: title ?? defaults.title,
      description: description ?? defaults.description,
      keywords: keywords ?? defaults.keywords,
      canonicalPath,
      ogImage,
      ogType,
      noindex: noindex ?? (privateRoute ? true : defaults.noindex),
      nofollow: nofollow ?? (privateRoute ? true : defaults.nofollow),
      jsonLd,
    });
  }, [
    pathname,
    title,
    description,
    keywords,
    canonicalPath,
    ogImage,
    ogType,
    noindex,
    nofollow,
    jsonLd,
  ]);

  return null;
}
